import { ElementType, ReactNode } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { Picture } from "@/components/wpl/image/src/image";

export interface PageHeadingProps<T extends ElementType> {
    as?: T;
    children: ReactNode;
}

export const PageHeading = <T extends ElementType>(
    props: PageHeadingProps<T>
) => {
    const { as: Component = "h1", children, ...rest } = props;

    const headingStyles = css({
        fontWeight: 700,
        lineHeight: "56px",
        textAlign: "center",
        margin: 0,
        [media.above.sm]: {
            fontSize: "48px"
        },
        [media.below.sm]: {
            fontSize: "44px"
        },
        [media.below.xs]: {
            fontSize: "40px"
        },
        // eslint-disable-next-line local/ensure-wac-token-usage
        color: "#101214"
    });

    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px"
            })}
        >
            {typeof children === "string" ? (
                <h1
                    css={headingStyles}
                    {...rest}
                    dangerouslySetInnerHTML={{ __html: children }}
                />
            ) : (
                <h1 css={headingStyles} {...rest}>
                    {children}
                </h1>
            )}
            <Picture
                image={{
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ox5132cg4k77h80v02063670d5th386i.svg",
                    alt: ""
                }}
            />
        </div>
    );
};
